import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      component () {
        return import(
          '@/src/server/components/Albums/Widget'
          // webpackChunkName: "albums"
        )
      },
      name: 'Albums',
      path: '/albums',
    },
    {
      component () {
        return import(
          '@/src/server/components/Articles/Widget'
          // webpackChunkName: "articles"
        )
      },
      path: '/articles',
      name: 'Articles',

    },
    {
      component () {
        return import(
          '@/src/server/components/Calendar/Widget'
          // webpackChunkName: "calendar"
        )
      },
      name: 'Calendar',
      path: '/calendar',
    },
    {
      component () {
        return import(
          '@/src/server/components/Videos/Widget'
          // webpackChunkName: "videos"
        )
      },
      name: 'Videos',
      path: '/videos',
    },
    {
      component () {
        return import(
          '@/src/server/components/Activities/Widgets/Activities'
          // webpackChunkName: "activities"
        )
      },
      name: 'Activities',
      path: '/activities',
    },
    {
      component () {
        return import(
          '@/src/server/components/Activities/Widgets/FeaturedActivities'
          // webpackChunkName: "featured-activities"
        )
      },
      name: 'Featured Activities',
      path: '/activities/featured',
    },
    {
      component () {
        return import(
          '@/src/server/components/Activities/Widgets/ActivitySummary'
          // webpackChunkName: "activity-summary"
        )
      },
      name: 'Activity Summary',
      path: '/activities/summary',
    },
  ],
})



// WEBPACK FOOTER //
// ./src/server/router/index.js